import { IEvent } from "@quest/adapter-interface";
import { detectDeviceEnvironmentConstants, ingenuity } from "@quest/base-core/dist";
import { AutoPlayPopUpView } from "@quest/murka-games-behavior-leopard/dist/Game/AutoPlayPopUp/AutoPlayPopUpView";
import { SlotConstantsBehavior } from "@quest/murka-games-behavior-leopard/dist";
import { gameConstants } from "../Constants/gameConstants";

export class AutoplayPopupViewGame extends AutoPlayPopUpView {

    /**
     * Methor overrided to update resizing for mobile
     */
    protected resize(evt: IEvent): void {
        super.resize(evt);
        if (ingenuity.deviceEnv.getOrientation() !== detectDeviceEnvironmentConstants.constants.ORIENTATION.PORTRAIT) {
            this.scale.set(ingenuity.deviceEnv.getLandcapeMaxReelScale())
            this.y = (innerHeight * SlotConstantsBehavior.HALF_CONVERTER) + ((gameConstants.REEL_BOTTOM_SPACE / 2) * this.scale.x);
            if (!ingenuity.deviceEnv.isDesktop) {
                this.y = (innerHeight * SlotConstantsBehavior.HALF_CONVERTER) + ((gameConstants.REEL_BOTTOM_SPACE_LANDSCAPE / 2) * this.scale.x);
            }
        }
    }
}

